<section class="main-content content-width mg-b5" id="main-content">
    <a onclick="closeNavMobile()" class="navbar__menu--mobile link-no-underline primary-color d-none d-sm-block"
            [ngClass]="{'hide-sidebar': hideSidebar}">
            <span class="icon-nav font-18" id="iconNavMobile"></span>
            <!-- <span class="icon-close font-25"></span> -->
    </a>
    <div class="header row">
        <div *ngIf="lastSync" class="d-inline-block right-dropdown col-lg-12 col-md-12 col-sm-12 col-12"><strong>Last Synced at</strong> {{lastSync | date:'d MMM, h:mm a'}} & <strong>Next at </strong>{{nextSyncDate | date:'d MMM, h:mm a'}}</div>
    </div>
    <div class="header row">
        <div ngbDropdown #activationDropDown="ngbDropdown" class="d-inline-block col-lg-8 col-md-7 col-sm-7 pd-l5 col-12">
            <button  type="button" class="btn btn-outline-primary left-dropdown placeholder-button" *ngIf="activations != undefined && activations.length === 1">{{activationSelected}}</button>
            <button *ngIf="activations != undefined && activations.length > 1" type="button" class="btn btn-outline-primary left-dropdown" id="dropdownBasic1" ngbDropdownToggle>
                {{activationSelected}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-down-values">
                <button *ngFor="let activation of activations" [value]="activation._id" ngbDropdownItem (click)="onActivationChange($event.target.value);activationDropDown.close()">{{activation.title}}</button>
            </div>
        </div>
        <!-- <select class="left-dropdown" (change)="onActivationChange($event.target.value)">
            <option *ngFor="let activation of activations" [value]="activation._id">{{activation.title}}</option>
        </select> -->
        <div ngbDropdown  #organisationDropDown="ngbDropdown" class="d-inline-block right-dropdown col-lg-4 col-md-5 col-sm-5 col-12" *ngIf="user?.role === 'ADMIN'">
            <button type="button" class="btn btn-outline-primary" id="dropdownBasic2" (click)="setFocus()" ngbDropdownToggle *ngIf="organizationSelected != null">
                {{(organizationSelected | slice:0:20) + (organizationSelected.length > 20 ? '...' : '')}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="drop-down-values no-transform">
                <input type="text" class="search searchInput" [ngModel]="searchValue" (ngModelChange)="filterDropdown($event)" #search>
                <button *ngFor="let organization of filteredList; let i=index" class="w-100" [value]="organization" ngbDropdownItem1 (click)="onOrganizationChange($event.target.value);organisationDropDown.close();">{{organization}}</button>
                <div *ngIf="filteredList.length <=0" class="text-center text-muted mt-1">No organizations found</div>
            </div>
            
        </div>
        <div class="d-inline-block right-dropdown col-lg-4 col-md-5 col-sm-5 col-12" *ngIf="user?.role === 'PARTNER_ADMIN'">
            <div class="right-dropdown">
                <img *ngIf="user.logo" class="pd-t5" [src]="user.logo">
                <span *ngIf="!user.logo" class="pd-t5">{{user.organization}}</span>
            </div>
        </div>
        <!-- <select class="right-dropdown" (change)="onOrganizationChange($event.target.value)">
            <option *ngFor="let organization of organizations"  [value]="organization">{{organization}}</option>
        </select> -->
    </div>
    <div class="header row">
        <div class="d-inline-block col-lg-6 col-md-5 col-sm-5 pd-l5 col-12">

        </div>
        <div ngbDropdown  #timezoneDropDown="ngbDropdown" class="d-inline-block right-dropdown col-lg-6 col-md-7 col-sm-7 col-12" *ngIf="user?.role === 'ADMIN'">
            <button type="button" class="btn btn-outline-primary" id="dropdownBasic2" (click)="setFocusTimezone()" ngbDropdownToggle *ngIf="timezoneSelected != null">
                {{(timezoneSelected | slice:0:50) + (timezoneSelected.length > 50 ? '...' : '')}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="drop-down-values no-transform">
                <input type="text" class="searchTimezone searchInputTimezone" [ngModel]="searchValue" (ngModelChange)="filterTimeZone($event)" #searchTimezone>
                <button *ngFor="let timezone of filteredTimezone; let i=index" class="w-100" [value]="timezone.value" ngbDropdownItem1 (click)="onTimezoneChange($event.target);timezoneDropDown.close();">{{timezone.label}}</button>
                <div *ngIf="filteredTimezone.length <=0" class="text-center text-muted mt-1">No timezone found</div>
            </div>
            
        </div>
    </div>
    <div class="row mobile-header">
        <div class="mobile-logo" [ngClass]="user?.role === 'PARTNER_ADMIN' ? 'col-6 col-sm-6' : 'col-5 col-sm-5'">
            <img src="assets/new-dashboard/mobile_logo.png" alt="" class="" />
        </div>
        <div ngbDropdown  #organisationDropDown="ngbDropdown" class="d-inline-block right-dropdown col-lg-5 col-md-6 col-sm-7 col-7" *ngIf="user?.role === 'ADMIN'">
            <button type="button" class="btn btn-outline-primary" id="dropdownBasic2" (click)="setFocus()" ngbDropdownToggle *ngIf="organizationSelected != null">
                {{(organizationSelected | slice:0:20) + (organizationSelected.length > 20 ? '...' : '')}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="drop-down-values no-transform">
                <input type="text" class="search searchInput" [ngModel]="searchValue" (ngModelChange)="filterDropdown($event)" #search>
                <button *ngFor="let organization of filteredList; let i=index" class="w-100" [value]="organization" ngbDropdownItem1 (click)="onOrganizationChange($event.target.value);organisationDropDown.close();">{{organization}}</button>
                <div *ngIf="filteredList.length <=0" class="text-center text-muted mt-1">No organizations found</div>
            </div>
            
        </div>
        <div class="d-inline-block right-dropdown col-lg-5 col-md-6 col-sm-6 col-6" *ngIf="user?.role === 'PARTNER_ADMIN'">
            <div class="right-dropdown">
                <img *ngIf="user.logo" class="pd-t5" [src]="user.logo">
                <span *ngIf="!user.logo" class="pd-t5">{{user.organization}}</span>
            </div>
        </div>
    </div>
    <div class="row mobile-header">
        <div ngbDropdown #activationDropDown="ngbDropdown" class="d-inline-block col-lg-7 col-md-6 col-sm-6 pd-l5 col-12">
            <button  type="button" class="btn btn-outline-primary left-dropdown placeholder-button" *ngIf="activations != undefined && activations.length === 1">{{activationSelected}}</button>
            <button *ngIf="activations != undefined && activations.length > 1" type="button" class="btn btn-outline-primary left-dropdown" id="dropdownBasic1" ngbDropdownToggle>
                {{activationSelected}}
            </button>
            <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="drop-down-values">
                <button *ngFor="let activation of activations" [value]="activation._id" ngbDropdownItem (click)="onActivationChange($event.target.value);activationDropDown.close()">{{activation.title}}</button>
            </div>
        </div>
        <div *ngIf="lastSync" style="padding-top: 20px;" class="d-inline-block right-dropdown col-sm-6 col-12"><strong>Last Synced at</strong> {{lastSync | date:'d MMM, h:mm a'}} & <strong>Next at </strong>{{nextSyncDate | date:'d MMM, h:mm a'}}</div>
    </div>
    
    <router-outlet></router-outlet>
</section>